import {
  Map,
  MapControl,
  MapControls,
  MapGeolocationCustomControl,
  MapZoomCustomControl,
  Route,
} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {memo} from 'react'

import {useConfigContext} from '../../../contexts'
import {MapPlacemarks} from '../MapPlacemarks/MapPlacemarks'
import * as classes from './FormMapUI.classes'
import {useFormMap} from './hooks'
import {type Props} from './types'
import {shouldInitializeLocation} from './utils'

export const FormMapUI = memo<Props>(function FormMapUI(props) {
  const {sourcePointCoordinates} = props
  const i18n = useI18n()
  const {location: userLocation} = useConfigContext()

  const {
    mapLocation,
    mapMargin,
    controlsPosition,
    lang,
    routePointCoordinates,
    geolocationClickHandler,
    isRouteVisible,
    location,
    orderPointsCoordinates,
    isDragPointAllowed,
    updateMapLocation,
    onPlacemarkChange,
    isOnlySourcePoint,
  } = useFormMap(props)

  return (
    <Map
      className={classes.map}
      errorMessage={i18n('map_load_error', 'Не удалось загрузить карту')}
      lang={lang}
      location={mapLocation}
      margin={mapMargin}
    >
      {isRouteVisible && <Route onBoundsChange={updateMapLocation} points={routePointCoordinates} />}
      <MapControls position={controlsPosition}>
        <MapControl>
          <MapZoomCustomControl setLocation={updateMapLocation} />
        </MapControl>
        <MapControl>
          <MapGeolocationCustomControl
            initializeLocation={shouldInitializeLocation(
              isRouteVisible,
              isOnlySourcePoint,
              sourcePointCoordinates,
              userLocation,
            )}
            initialLocation={location}
            onGeolocatePosition={geolocationClickHandler}
          />
        </MapControl>
      </MapControls>
      <MapPlacemarks
        allPoints={orderPointsCoordinates}
        isDragPointAllowed={isDragPointAllowed}
        onChange={onPlacemarkChange}
        onLocationRequest={updateMapLocation}
        route={routePointCoordinates}
      />
    </Map>
  )
})
